import React from 'react';
import { useSelector } from 'react-redux';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';

import Icon from '../../../../../icons/Icon';
import { ICONS } from '../../../../../icons';
import WithLabel, { LABEL_STYLES } from '../../../../../components/with-label/WithLabel';

import scss from './DatasetErrors.module.scss';
import parentScss from '../SonarCreationForm.module.scss';

const ErrorSection = ({ title, lines }) => {
  return (
    <li className={scss.errorSection}>
      <Icon icon={ICONS.Cross} disableCommonColors />
      <span>{title}:</span>
      <span>{lines.join(', ')}</span>
    </li>
  );
};

const DatasetErrors = () => {
  const datasetErrors = useSelector((state) => state.createSonar.datasetErrors);
  const { t } = useTranslation('projects');

  if (!Object.entries(datasetErrors).length) {
    return null;
  }

  return (
    <WithLabel
      variant={LABEL_STYLES.ALIGNED}
      label={`${t('importErrors')}:`}
      isBold
      extraClassName={clsx(parentScss.inputRow, scss.wrapper)}>
      <ul className={scss.list}>
        {Object.entries(datasetErrors).map(([title, lines]) => (
          <ErrorSection key={title} title={title} lines={lines} />
        ))}
      </ul>
    </WithLabel>
  );
};

export default DatasetErrors;
